import { useEffect, useState } from "react";
import Header from "../components/Header";
import { getSystemContents } from "../services/statistics";

export default function Ruls() {
  const [rules, setRules] = useState();
  useEffect(() => {
    getSystemContents().then((res) => {
      if (res.status == 200) {
        let data = res?.data?.results;
        for (let d of data) {
          if (d.key === "terms_and_conditions") {
            setRules(d.value);
          }
        }
      }
    });
  }, []);
  return (
    <>
      <Header />
      <div>
        <div className="page-content">
          <div className="container">
            <div className="content-description">{rules}</div>
          </div>
        </div>
      </div>
    </>
  );
}
